define('modules/form_editor/models/custom_google_recaptcha',['require','exports','module','./base_form_element','modules/editor/models/editorstate','../config'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element"),
    EditorState = require("modules/editor/models/editorstate"),
    CaptchaConfig = require("../config");

  module.exports = BaseFormElement.extend({
    name: "custom:captcha:google_recaptcha",
    isIntegrable: false,
    onlyFieldAttrs: true,
    defaultValues: {
      renderMode: CaptchaConfig.googleRecaptcha.defaultRenderMode,
      idName: "lpg-google-captcha",
      URL: CaptchaConfig.googleRecaptcha.urlBase
    },

    initialize: function() {
      module.exports.__super__.initialize.apply(this, arguments);
      this.set('siteKey', CaptchaConfig.googleRecaptcha.getSiteKey());
      this.on("change:siteKey", this.notifySiteKey);
    },

    notifySiteKey: function() {
      EditorState.setVariantChanged(true, true);
    }
  });
});

